<template>
    <div v-if="state">
        <PopForm width="610px" body-max-height="760px">
            <template v-slot:title>同步配置</template>

            <!--内容-->
            <el-form class="form-box" ref="form" :model="formData" :rules="rules" label-width="100px">
                <el-form-item label="选择配置：" prop="option">
                    <el-checkbox-group v-model="formData.option">
                        <el-checkbox v-for="val in optionArr" :label="val.value">{{val.label}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="同步至：" prop="to">
                    <ChainCheckStore v-model="formData.to" placeholder="请选择门店" />
                </el-form-item>
            </el-form>

            <!--底部-->
            <template v-slot:foot>
                <div class="pop-foot">
                    <el-button size="medium" @click="close">&nbsp;&nbsp;关闭&nbsp;&nbsp;</el-button>
                    <el-button size="medium" type="primary" @click="submitEvent">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                </div>
            </template>
        </PopForm>


    </div>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import ChainCheckStore from "@/model/Chain/ChainCheckStore";
    export default {
        name: "ChainSyncOption",
        components: {ChainCheckStore, PopForm},
        model: {
            prop: "state",
            event: "stateChange"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                optionArr: [
                    // {
                    //     label: "项目配置",
                    //     value: "product"
                    // }
                ],
                formData: {
                    option: [],
                    to: ""
                },
                rules: {
                    option: [
                        {required: true, message: "请选择要同步的配置", trigger: "blur"}
                    ],
                    to: [
                        {required: true, message: "请选择同步至哪个门店?", trigger: "blur"}
                    ]
                },
                allStoreList: []
            };
        },
        mounted(){
            this.loadAllOption();
            this.loadChainStore();
        },
        methods: {
            //初始化
            init(){
                this.formData = {
                    option: [],
                    to: ""
                };
            },
            loadAllOption(){
                this.$root.postData("chain/get_allow_sync_store_option", {}, res => {
                    if(res.errcode === 0) {
                        this.optionArr = res.data;
                    }
                });
            },
            //加载所有连锁门店
            loadChainStore() {
                this.$root.postData("chain/get_child_store_list_short", {}, res => {
                    if(res.errcode === 0){
                        let allStore = [];
                        res.data.forEach(val => {
                            if(val.is_main !== "1") {
                                allStore.push(val);
                            }
                        });
                        this.allStoreList = allStore;
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            },
            //关闭
            close(){
                this.$emit("stateChange", false);
            },
            //确定
            submitEvent(){
                this.$refs["form"].validate( r => {
                    if(!r) return false;

                    let postData = {
                        option: this.formData.option.join("|"),
                        to: this.formData.to.join(","),
                    };
                    this.$root.postData("chain/sync_store_option", postData, res => {
                        if(res.errcode === 0){
                            this.$root.success(res.data);
                        }else{
                            this.$root.error(res.errdesc);
                        }
                        this.close();
                    });
                })
            }
        },
        watch: {
            state(val){
                if(val) this.init();
            }
        }
    }
</script>

<style scoped>

</style>
